export function getIaGroupNameWithDate(group: { startDate: Date; formattedName: string }) {
  if (group) {
    const startDate: Date = new Date(group.startDate);
    return `${group.formattedName} - ${startDate.toLocaleDateString()}`;
  } else {
    return '-';
  }
}
